export * from "./ToggleButton";

export interface IToggleButtonStyleProps {
    Checked: boolean;
}

export interface IToggleButtonProps {
    CheckedCaption: string;
    UncheckedCaption: string;
    Toggled: boolean;
    Disabled?: boolean;
    OnClick: (checked: boolean) => void;
}
